Promise.all([
  import('../../plugins/semantic/modal.scss'),
  import('../../plugins/semantic/modal'),
  import('./tab-current-deals.scss'),
]).then(() => {
  $('.widget.tab-current-deals').each(function (i, el) {
    $(el).data('widget', new TabCurrentDeals(el))
    $(el).data('widget').init()
  })
})

function TabCurrentDeals(el) {
  const self = this
  self.el = $(el)
  self.isLoaded = false
  self.dealTemplate = require('./tab-current-deals.hbs')

  self.render = function (data) {
    // Iterate over each deal in AvailableDeals to rewrite the url
    data.AvailableDeals.forEach(function (deal) {
      if (deal.CtaLabel == "Remove" && window.location.search.includes(deal.PromoCode) && deal.Restricted == true) {
        deal.Restricted = false;
      }
    });
    const html = self.dealTemplate(data)
    self.el.find('.results').html(html)

    // Append pages params to deals links as required
    var params = window.location.href.split('?')[1]
    if (!params) return
    self.el.find('.append-querystring').each(function (i, el) {
      let href = $(el).attr('href')
      // checking for any elemnts that have the Remove contexts for each element
      if ($(el)[0].textContent == 'Remove') {
        const url = window.location.href;
        const urlParams = new URLSearchParams(new URL(url).search);
        const dealCode = urlParams.get('dealCode');
        const propertyCode = urlParams.get('propertyCode');
        
        //.find(d => href.includes(d.PromoCode));
        let newUrl = "/deals/"+propertyCode+"/" + dealCode + "/remove" + window.location.search;
        $(el).attr('href', `${newUrl}`);
      }
      else {
        $(el).attr('href', `${href}?${params}`)
      }
  })
}

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('TabCurrentDeals init', self)
    }
    self.el.css('opacity', 1)

    self.termsModal = self.el.find('.terms-popup').modal()
    self.el.on('click', '.expander', function (e) {
      e.preventDefault()
      self.termsModal.find('.content').html($(this).siblings('.content').html())
      self.termsModal.modal('show')
    })


    $(document).on("click", ".tab-close-button", function(e) {
      e.preventDefault(); // Prevent the default action of the click event
      //Just using the pop up modules
      $('.icon-close').click();
  });


    window.dbs.globalEvents.subscribe('deals_updated', function (deals) {
      if(process.env.NODE_ENV === 'development') {
        console.log('TabCurrentDeals deals_updated event received', deals)
      }
      if (deals.AvailableDeals && deals.AvailableDeals.length) {
        self.render(deals)
        const name = self.el.parents('.tab-content').attr('data-tab')
        const checkCurrentDealsIsOpen =$('div.tab[data-tab="current-deals"]').hasClass('active');
        if (checkCurrentDealsIsOpen)
        {
          window.dbs.globalEvents.emit('reload_tab', name, true);
        }
      } else {
        // If there is no tab content to show, remove the tab from the page
        // Possibly remove deal here if there's no deals showing
        const name = self.el.parents('.tab-content').attr('data-tab')
        // This will remove deal tab completely instead of hiding it, to prevent first tab display bug
        self.el.parents('.park-summary-tabs').find(`.tab-container .tab[data-tab="${name}"]`).remove();
        window.dbs.globalEvents.emit('remove_tab', name, true)
      }

      if (!self.isLoaded) {
        window.dbs.globalEvents.emit('tab_loaded', null, true)
        self.isLoaded = true
      }
    })

    window.dbs.globalEvents.subscribe('was_tab_loaded', function () {
      if (self.isLoaded) {
        window.dbs.globalEvents.emit('tab_loaded', null, true)
      }
    })
  }
}
